<template>
  <transition name="slide-right">
    <div class="flex flex-col fixed pin-y pin-r mt-11 lg:mt-12 px-4 pt-4 w-full lg:w-2/5 bg-white z-1000">
      <HideModalButton :onClickHide="onClickHide" />
      <div class="flex flex-col mt-6 mb-2">
        <div class="text-black text-xl">{{ district.nama_kabkota }}</div>
        <div class="text-grey-dark text-sm">{{ province.nama }}</div>
      </div>
      <div class="mt-4">
        <button class="bg-success hover:bg-success-dark text-white text-xs font-bold py-1 px-2 rounded mr-2" @click="showRecap">
          Tinjau Tabel Kebutuhan
        </button>
        <button class="bg-info hover:bg-info-dark text-white text-xs font-bold py-1 px-2 rounded" @click="showMutations">
          Daftar Redistribusi
        </button>
      </div>
      <div class="mt-6">
        <ul class="list-reset flex border-b">
          <li :class="selectedLevel === 'SD' ? '-mb-px mr-1' : 'mr-1'">
            <a :class="selectedLevel === 'SD' ? 'border-l border-t border-r rounded-t text-blue-dark font-semibold' : 'text-blue hover:text-blue-darker'" class="bg-white inline-block py-2 px-4 text-xs no-underline" href="#" @click="changeSelectedLevel('SD')">SD</a>
          </li>
          <li :class="selectedLevel === 'SMP' ? '-mb-px mr-1' : 'mr-1'">
            <a :class="selectedLevel === 'SMP' ? 'border-l border-t border-r rounded-t text-blue-dark font-semibold' : 'text-blue hover:text-blue-darker'" class="bg-white inline-block py-2 px-4 text-xs no-underline" href="#" @click="changeSelectedLevel('SMP')">SMP</a>
          </li>
          <li :class="selectedLevel === 'SMA' ? '-mb-px mr-1' : 'mr-1'">
            <a :class="selectedLevel === 'SMA' ? 'border-l border-t border-r rounded-t text-blue-dark font-semibold' : 'text-blue hover:text-blue-darker'" class="bg-white inline-block py-2 px-4 text-xs no-underline" href="#" @click="changeSelectedLevel('SMA')">SMA</a>
          </li>
        </ul>
      </div>
      <div class="overflow-y-auto h-full p-4 -mx-4 flex flex-col">
        <div v-if="isFetchingStats" class="flex mt-32 mx-auto">
          <v-icon name="spinner" scale="2" pulse class="text-brand" />
        </div>
        <div v-else>
          <course-chart v-show="isDataAvailable" :level="selectedLevel" :stats="stats" :on-select="() => {}" />
          <div v-show="!isDataAvailable" class="text-black text-xs p-4">
            -- Data tidak ditemukan --
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import CourseChart from '@/components/Charts/CourseChart'
import HideModalButton from '@/components/HideModalButton'
import { mapState } from 'vuex'
import {
  TOGGLE_MODAL_DISTRICT,
  TOGGLE_MODAL_MUTATIONS,
  TOGGLE_MODAL_RECAP_DISTRICT
} from '@/mutationTypes'

export default {
  name: 'modal-district',
  components: {
    CourseChart,
    HideModalButton
  },
  created () {
    this.fetchStats()
  },
  computed: {
    ...mapState(['selectedProvince', 'selectedDistrict']),
    province () {
      return this.selectedProvince || { nama: '' }
    },
    district () {
      return this.selectedDistrict || { nama_kabkota: '' }
    }
  },
  watch: {
    selectedDistrict () {
      this.fetchStats()
    }
  },
  data () {
    return {
      selectedLevel: 'SD',
      isFetchingStats: false,
      isDataAvailable: false,
      stats: {
        chart: [],
        colors: {}
      }
    }
  },
  methods: {
    async fetchStats () {
      try {
        this.isFetchingStats = true
        let response = await this.$http.get(process.env.VUE_APP_API_URL + '/api/simrasio/formasi/' + this.selectedLevel + '/kabKota/' + this.selectedDistrict.kode_wilayah)
        this.isFetchingStats = false
        let json = response.data
        if (json.status === 200) {
          this.isDataAvailable = true
          this.stats = {
            chart: json.result.properties.chart,
            colors: json.result.properties.colors
          }
        } else {
          this.isDataAvailable = false
        }
      } catch (err) {
        // console.log(err)
        this.isDataAvailable = false
      }
    },
    changeSelectedLevel (level) {
      this.selectedLevel = level
      this.fetchStats()
    },
    onClickHide () {
      this.$store.dispatch(TOGGLE_MODAL_DISTRICT, false)
    },
    showRecap () {
      this.$store.dispatch(TOGGLE_MODAL_RECAP_DISTRICT, true)
    },
    showMutations () {
      this.$store.dispatch(TOGGLE_MODAL_MUTATIONS, {
        status: true,
        type: 'district'
      })
    }
  }
}
</script>
